'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/sendbird/~/axios/lib/cancel/isCancel.js
// module id = 561
// module chunks = 42